import React from "react";
import logoImage from "../../img/logo.png";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer_section py-12 bg-[#090817] text-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-between items-start">
          
          {/* Column 1: Brand Logo, Tagline & Social Icons */}
          <div className="space-y-5">
            <a href="/" aria-label="Crosslinker Home">
              <img
                src={logoImage}
                alt="Crosslinker"
                width={200}
                height={60}
                className="w-[180px] lg:w-[200px] h-auto object-contain"
              />
            </a>
            <p className="text-[15px] font-normal text-gray-200 leading-snug">
              Global Labs on Cloud <span className="font-bold text-sm">™</span>
              <br />
              Compliance & Certifications
            </p>
            <div className="socials flex items-center space-x-4 pt-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/crosslinker.usa"
                aria-label="Facebook"
                className="hover:opacity-80 transition-opacity"
              >
                <svg
                  fill="#d926a9"
                  viewBox="0 0 320 512"
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"></path>
                </svg>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/crosslinker.usa/"
                aria-label="Instagram"
                className="hover:opacity-80 transition-opacity"
              >
                <svg
                  fill="#d926a9"
                  viewBox="0 0 512 512"
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M349.33 69.33a93.62 93.62 0 0 1 93.34 93.34v186.66a93.62 93.62 0 0 1-93.34 93.34H162.67a93.62 93.62 0 0 1-93.34-93.34V162.67a93.62 93.62 0 0 1 93.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z"></path>
                  <path d="M377.33 162.67a28 28 0 1 1 28-28 27.94 27.94 0 0 1-28 28zM256 181.33A74.67 74.67 0 1 1 181.33 256 74.75 74.75 0 0 1 256 181.33m0-37.33a112 112 0 1 0 112 112 112 112 0 0 0-112-112z"></path>
                </svg>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://x.com/CrosslinkerAi"
                aria-label="X (Twitter)"
                className="hover:opacity-80 transition-opacity"
              >
                <svg
                  fill="#d926a9"
                  viewBox="0 0 512 512"
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
                </svg>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/crosslinker"
                aria-label="LinkedIn"
                className="hover:opacity-80 transition-opacity"
              >
                <svg
                  fill="#d926a9"
                  viewBox="0 0 448 512"
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
                </svg>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/@crosslinker4948/about"
                aria-label="YouTube"
                className="hover:opacity-80 transition-opacity"
              >
                <svg
                  fill="#d926a9"
                  viewBox="0 0 576 512"
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Link */}
          <div className="space-y-3">
            <h6 className="text-[22px] font-bold text-white tracking-tight">
              Quick Link
            </h6>
            <ul className="space-y-2.5">
              <li>
                <a href="https://crosslinker.us/" className="footer-link">
                  Home
                </a>
              </li>
              <li>
                <a href="https://crosslinker.us/about-us" className="footer-link">
                  About
                </a>
              </li>
              <li>
                <a href="https://crosslinker.us/blog" className="footer-link">
                  Blog
                </a>
              </li>
              <li>
                <a href="https://crosslinker.us/case-studies" className="footer-link">
                  Case Studies
                </a>
              </li>
              <li>
                <a href="https://crosslinker.us/contact-us" className="footer-link">
                  Contact
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="footer-link">
                  Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Contacts */}
          <div className="space-y-3">
            <h6 className="text-[22px] font-bold text-white tracking-tight">
              Contacts
            </h6>
            <ul className="space-y-5 text-gray-300">
              <li className="flex items-start gap-3.5">
                <span className="mt-0.5 text-white shrink-0">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-7 h-7"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9 22 9 12 15 12 15 22" />
                  </svg>
                </span>
                <div>
                  <div className="text-white text-[15px] font-semibold leading-snug">
                    Address
                  </div>
                  <div className="text-[14px] text-gray-300 leading-snug">
                    5270 California Avenue <br /> Irvine, CA 92697
                  </div>
                </div>
              </li>

              <li className="flex items-center gap-3.5">
                <span className="text-white shrink-0">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-7 h-7"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                <div>
                  <div className="text-white text-[15px] font-semibold leading-snug">
                    Phone
                  </div>
                  <a
                    href="tel:+1.800.365 2131"
                    className="text-[14px] text-gray-300 hover:text-white transition-colors"
                  >
                    +1.800.365 2131
                  </a>
                </div>
              </li>

              <li className="flex items-center gap-3.5">
                <span className="text-white shrink-0">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-7 h-7"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                <div>
                  <div className="text-white text-[15px] font-semibold leading-snug">
                    Email
                  </div>
                  <a
                    href="mailto:atul@crosslinker.ai"
                    className="text-[14px] text-gray-300 hover:text-white transition-colors"
                  >
                    atul@crosslinker.ai
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright Bar */}
        <div className="mt-12 pt-4 text-center text-sm text-gray-300">
          <p>
            2026 © All Rights Reserved by{" "}
            <strong className="font-bold text-white">CROSSLINKER LLC</strong>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
